import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { BoatGroup } from '../boatList/BoatDetails';
import * as Icons from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../app/store';
import { addGroup } from '../boatList/boatListSlice';
import { randomGroup } from '../../TestData';
import { GroupDetailsCard } from './GroupDetailsCard';
import { analyticsService } from '../../services/AnalyticsService';


export function GroupList() {
  const boatList = useSelector((state: RootState) => state.boatList);
  const dispatch: AppDispatch = useDispatch();

  function onClick() {
    const newGroup: BoatGroup = randomGroup();
    console.log('GroupList onClick', newGroup);

    // Track group creation
    analyticsService.logEvent('boat_management', {
      action_type: 'add_group',
      feature_name: 'group_list',
      handicap_system: newGroup.handicapSystem,
      group_count: boatList.boatGroupList.length + 1,
    });

    dispatch(addGroup(newGroup));
  }

  console.log('GroupList.render', boatList);

  return <Container>
    <Row xs={1} sm={2} md={3} lg={4} xl={5} xxl={6} className="g-4">
      {boatList.boatGroupList.map((group: BoatGroup) => <Col key={group.id}>
        <GroupDetailsCard group={group} currentGroup={group.id === boatList.currentGroupId} />
      </Col>)}
      <Col key='add'>
        <Card>
          <Card.Body onClick={onClick} className='cursor-pointer'>
            <Card.Text>
              <Icons.PlusLg size="2em" />
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>;
}
